import { render, staticRenderFns } from "./Logo.component.vue?vue&type=template&id=486beadf&scoped=true"
import script from "./Logo.component.vue?vue&type=script&lang=js"
export * from "./Logo.component.vue?vue&type=script&lang=js"
import style0 from "./Logo.component.vue?vue&type=style&index=0&id=486beadf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486beadf",
  null
  
)

export default component.exports